import { render, staticRenderFns } from "./requestList.vue?vue&type=template&id=8b88dcf4"
import script from "./requestList.vue?vue&type=script&lang=js"
export * from "./requestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports